import { SiriusEnvironment } from "sirius-platform-support-library/tenants/tenant-context";
export const environmentsDefinitions = {
    LOCAL: {
        origins: [
            'localhost.dell.com'
        ],
        siriusEnvironment: SiriusEnvironment.LOCAL
    },
    STAGING: {
        origins: [
            'csm-td-staging.dell.com',
            'sirius-staging-migration.z1r3.pcf.dell.com'
        ],
        siriusEnvironment: SiriusEnvironment.STAGING
    },
    INT: {
        origins: [
            'csm-td-int.dell.com'
        ],
        siriusEnvironment: SiriusEnvironment.INTEGRATION
    },
    PROD: {
        production: true,
        origins: [
            "tdm.dell.com"
        ],
        siriusEnvironment: SiriusEnvironment.PRODUCTION
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aXJvbm1lbnRzLWRlZmluaXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnRleHQvZW52aXJvbm1lbnRzLWRlZmluaXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBd0IsaUJBQWlCLEVBQUMsTUFBTSx3REFBd0QsQ0FBQztBQUVoSCxNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBMEM7SUFDMUUsS0FBSyxFQUFFO1FBQ0gsT0FBTyxFQUFFO1lBQ0wsb0JBQW9CO1NBQ3ZCO1FBQ0QsaUJBQWlCLEVBQUUsaUJBQWlCLENBQUMsS0FBSztLQUM3QztJQUNELE9BQU8sRUFBRTtRQUNMLE9BQU8sRUFBRTtZQUNMLHlCQUF5QjtZQUN6Qiw0Q0FBNEM7U0FDL0M7UUFDRCxpQkFBaUIsRUFBRSxpQkFBaUIsQ0FBQyxPQUFPO0tBQy9DO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsT0FBTyxFQUFFO1lBQ0wscUJBQXFCO1NBQ3hCO1FBQ0QsaUJBQWlCLEVBQUUsaUJBQWlCLENBQUMsV0FBVztLQUNuRDtJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRSxJQUFJO1FBQ2hCLE9BQU8sRUFBRTtZQUNMLGNBQWM7U0FDakI7UUFDRCxpQkFBaUIsRUFBRSxpQkFBaUIsQ0FBQyxVQUFVO0tBQ2xEO0NBQ0osQ0FBQyJ9